import Phaser from "phaser";
import { isItemVisible } from "./scrollVirtualize.js";

export interface ScrollableContentItem {
  readonly obj: Phaser.GameObjects.GameObject;
  lx: number;
  ly: number;
}

export function setScrollableItemInputEnabled(obj: Phaser.GameObjects.GameObject, enabled: boolean): void {
  (obj as Phaser.GameObjects.GameObject & { setActive?: (value: boolean) => unknown }).setActive?.(
    enabled,
  );
  const input = (obj as Phaser.GameObjects.GameObject & { input?: { enabled: boolean } }).input;
  if (input) input.enabled = enabled;
  const children = (obj as Phaser.GameObjects.GameObject & { list?: Phaser.GameObjects.GameObject[] }).list;
  if (!children) return;
  for (const child of children) setScrollableItemInputEnabled(child, enabled);
}

export function syncScrollableItemState(
  item: ScrollableContentItem,
  frozen: ReadonlySet<Phaser.GameObjects.GameObject>,
  scrollY: number,
  viewportHeight: number,
  itemMargin: number,
  contentInputEnabled: boolean,
): void {
  if (frozen.has(item.obj)) return;
  const visible = isItemVisible(item.ly, scrollY, viewportHeight, itemMargin);
  (item.obj as unknown as Phaser.GameObjects.Components.Visible).setVisible(visible);
  setScrollableItemInputEnabled(item.obj, contentInputEnabled && visible);
  (item.obj as unknown as Phaser.GameObjects.Components.Transform).setPosition(item.lx, item.ly - scrollY);
}
